var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"add-button",on:{"click":function($event){$event.preventDefault();return _vm.act($event)}}},[_c('span',{staticClass:"icon-add"})]),_c('primary-button',{attrs:{"title":_vm.title,"act":_vm.act}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }